// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__a0qnF","legacyBtn":"MutateMid_legacyBtn__31V9U"};